import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer

import ProductForm from '../../components/product/ProductForm.vue'
let service = new services();

export default {
    name: 'SideHustle',
    data () {
        return {
            user: {},
            sellpoint: {},
            categories:{},
            details:{},
            contact_form: {},
            category:{},
            service:{},
            delivery_option:{},
            products: {},
            product:{},
            market:{},
            product_item: {},
            can_edit: false,
            edit_mode:false,
            disable_btn: false,
            setPanel: false,
            listView:true,
            marketView:false,
            addProductPanel:false,
            spProductsPanel:false,
            spMarketPanel:false,
            spProfilePanel:false,
            spContactPanel:false,
            spDeliveryPanel:false,
            createSellpointPanel: false,
            viewAllProductsBanner:false,
            showSidebarMobile:false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            bg_main:''
            
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'product-form': ProductForm
     },
    methods: {
        setComponent(attr1,attr2){
            this.setPanel = true;
            if(attr1 == 'create-sellpoint'){
                this.createSellpointPanel= true;
                this.addProductPanel= false;
            }
            if(attr1 == 'sellpoint-panel'){
                this.addProductPanel= false;
            }
            if(attr1 == 'spProductsPanel'){
                this.spMarketPanel = false;
                this.spProductsPanel= true;
                this.spProfilePanel=false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;

                //check for market
                if(attr2 == 'market'){
                    this.spMarketPanel = true;
                }
            }
            if(attr1 == 'spProfilePanel'){
                this.spProductsPanel= false;
                this.spProfilePanel= true;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
            }
            if(attr1 == 'spContactPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= true;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
            }
            if(attr1 == 'spDeliveryPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = true;
            }
            if(attr1 == 'add-product'){
                this.addProductPanel= true;
                this.createSellpointPanel= false;
            }
            if(attr1 == 'edit-category'){
                this.category.edit = false;
                this.category = attr2;
                this.category.edit = true;
            }
            if(attr1 == 'reset-edit-category'){
                this.category.edit = false;
                this.category = {}
            }
            if(attr1 == 'view-all-products'){
                this.viewAllProductsBanner = false;
                this.getSellpointProducts();
            }
            if(attr1 == 'list-view'){
                this.marketView = false;
                this.listView = true;
            }
            if(attr1 == 'market-view'){
                this.marketView = true;
                this.listView = false;
            }
        },

        setComponentActions(attr1,attr2){
            if(attr1 == 'edit-service'){
                this.service.edit_set = false;
                this.service = attr2;
                this.service.edit_set = true;
            }
            if(attr1 == 'edit-delivery-option'){
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if(attr1 == 'edit-tagline'){
                this.details = {};
                this.details.tagline_edit = true;
            }
            if(attr1 == 'edit-profile'){
                this.details = {};
                this.details.profile_edit = true;
            }
            if(attr1 == 'edit-contact-info'){
                this.details = {};
                this.details.contact_info_edit = true;
            }
            if(attr1 == 'edit-delivery-information'){
                this.details = {};
                this.details.delivery_edit = true;
            }
            if(attr1 == 'reset-edit'){
                this.details = {};
            }
        },
        
        prep: function() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");
            //return Home;
            return parts[0];
        },

        toggleSidebar(){
            if(this.showSidebarMobile == true){
                this.showSidebarMobile = false;
            }else{
                this.showSidebarMobile = true;
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            //set sellpoint and seller options
                           this.setSellpoint();
                        }, this);
                    }else {
                        this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        is_editing(){ //preseting if seller
            if(this.user.user_id != ""){
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                }
                service.can_edit(this, payload).then(response => {
                    if(response.body.status == 200) {
                        this.edit_mode =  true;
                        this.can_edit = true;
                    }else {
                        this.edit_mode =  false;
                    }
                }).catch((err) => {
                    if(err) {
                        //log error
                    }
                })
            }
        },

        switchMode(){
            if(this.edit_mode == false){
                this.is_editing(); //revalidate seller
            }else{
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        
        setSellpoint(){
            let sp = "";
            if(this.$route.params.id != undefined){
                sp = this.$route.params.id;
             }
            else{
                sp = this.prep();
            }
            service.getBusinessByUserName(this, "blazers").then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data;
                    this.is_editing();
                    this.getCategories(this.sellpoint.business_category_id);
                    this.getSellpointProducts(); // if basic sellpoint
                    if(this.sellpoint.business_market_category_id != 0){
                        this.getSellpointMarket();
                        localStorage.setItem("sp_#_sellpoint",this.sellpoint.business_username);
                    }
                    this.spProductsPanel = true; //use loaders subsequently to make sure other above is loaded
                }
            }).catch((err) => {
                //log it
                location.replace("/");
               //console.log(err)
            })
        },

        getSellpointProducts(){
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSellpointMarket(){
            service.getBusinessMarket(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getCategories(category){
            service.getBusinessSubCategories(this, category).then(response => {
                if(response.body.status == 200) {
                    this.categories = response.body.data;
                }
            }).catch((err) => {})
                
        },


        sendBusinessContactForm(){
            var payload = {
                business_id: this.sellpoint.business_id,
                contact_form_name: this.contact_form.name || "nill",
                contact_form_email: this.contact_form.email || "nill",
                contact_form_message: this.contact_form.message || "nill"
            }
            service.sendBusinessContactForm(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    toastr.success("Message Sent", 'Ok!');
                }
                this.contact_form = {};
            }).catch((err) => {
                //log it
                this.contact_form = {};
            })
        },

},
mounted: function(){
    if((localStorage.getItem("sp_token")) != undefined){
        this.preset();
    }
},
created: function(){
    //this.setSellpoint();
    if((localStorage.getItem("sp_token")) != undefined){
        this.preset();
    }else{
        this.setSellpoint();
    }
    
}
}


// WEBPACK FOOTER //
// ./src/pages/SideHustle/script.js